import { SectionLayout } from '../components/SectionLayout';
import { useCardScanSummary } from '../features/cardScans/api';
import { useFeatures } from '../features/settings/api';
import { TOOLS_SECTIONS } from './sections';

/** Tools hub, with the number of scanned cards waiting to be checked next to Scan cards. */
export function ToolsLayout() {
  const cardsOn = useFeatures().enabled('cardScanner');
  const cards = useCardScanSummary(cardsOn);
  return <SectionLayout title="Tools" items={TOOLS_SECTIONS} badges={{ '/tools/scan-cards': cardsOn ? (cards.data?.ready ?? 0) : 0 }} />;
}
